import { AccessoryModel } from '../utils/Models';
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { Colors } from '../../config/Constants';
import { Box, IconButton } from '@mui/material';
import { ArrowForwardIos, Close, DeleteForever } from '@mui/icons-material';

// Booking grid component
export function AccessoryTable(props: {
  accessoryList: AccessoryModel[],
  setParentState: any,
  containerClass: any,
  deleteAccessory: (accessoryId: number) => any
}) {
  const dgProps = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    className: 'gbk-dg',
    rowHeight: 50,
    pageSize: 10,
    columns: [{
      field: 'name',
      headerName: 'Name',
      width: 250,
      align: 'center',
      renderCell: o => (<span><div className='gbk-dg-image-text'>{o.value}</div>&nbsp;&nbsp;<img className='gbk-dg-image' alt='accessory' src={o.row.image} /></span>),
      sortable: false
      // }, {
      //   field: 'accType',
      //   headerName: 'Calculation',
      //   width: 180,
      //   align: 'center',
      //   renderCell: o => <b style={{ color: Colors.primary }}>{o.row.hub_accessories.accessoryType}</b>,
      //   sortable: false
      // }, {
      //   field: 'price',
      //   headerName: 'Price',
      //   width: 180,
      //   align: 'center',
      //   renderCell: o => <b>₹ {o.row.hub_accessories.price}</b>,
      //   sortable: false
    }, {
      field: 'details',
      headerName: 'Details',
      width: 110,
      align: 'center',
      renderCell: o => (
        <div
          style={{ color: Colors.primary, cursor: 'pointer' }}
          onClick={() => props.setParentState({ error: '', loading: false, view: 'individual', accData: o.row })}>
          View Details
        </div>
      ),
      sortable: false
    }, {
      field: 'actions',
      headerName: 'Delete',
      width: 110,
      align: 'center',
      renderCell: (o: { row: AccessoryModel }) => (
        <IconButton size='small' color='error' onClick={() => { props.deleteAccessory(o.row.id) }}>
          <DeleteForever />
        </IconButton >
      ),
      sortable: false
    }] as GridColumns
  }

  return <div className={props.containerClass}>
    {/* PC Grid */}
    <DataGrid
      sx={{ display: { xs: 'none', md: 'flex' } }}
      disableColumnMenu={dgProps.disableColumnMenu}
      disableColumnFilter={dgProps.disableColumnFilter}
      className={dgProps.className}
      rowHeight={dgProps.rowHeight}
      rows={props.accessoryList || []}
      columns={dgProps.columns}
      pageSize={dgProps.pageSize}
      rowsPerPageOptions={[dgProps.pageSize]}
      disableSelectionOnClick
    />
    {/* Phone Grid */}
    <DataGrid
      sx={{ display: { xs: 'flex', md: 'none' } }}
      disableColumnMenu={dgProps.disableColumnMenu}
      disableColumnFilter={dgProps.disableColumnFilter}
      className={`${dgProps.className} phone`}
      rowHeight={147}
      rows={props.accessoryList || []}
      columns={dgProps.columns}
      pageSize={dgProps.pageSize}
      rowsPerPageOptions={[dgProps.pageSize]}
      disableSelectionOnClick
      headerHeight={0}
      components={{
        Row: (data: { row: AccessoryModel }) => (
          <Box className='gbk-dg-row-phone'>
            <Box className='gbk-dg-row-phone-header' key={1} >
              {data.row.name}
              <div
                style={{ float: 'right', background: Colors.failureRed, borderRadius: '50%', padding: '3px', marginTop: '-2px' }}
                onClick={() => { props.deleteAccessory(data.row.id) }}
              >
                <span className="gbk-icon-span" style={{ color: 'white' }} >
                  <Close />
                </span>
              </div>
            </Box>
            <Box
              className='gbk-dg-row-phone-body'
              key={2}
              onClick={() => props.setParentState({ error: '', loading: false, view: 'individual', accData: data.row })}
            >
              <Box sx={{ float: 'left', verticalAlign: 'top' }}>
                <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
                  <img src={data.row.image} style={{ height: '38px', width: 'auto' }} alt="bike" />
                </div>
              </Box>
              <Box sx={{ float: 'right' }}>
                {/* <b>₹ {data.row.totalRentalAmount}</b> */}
                <span style={{ color: Colors.primary }} className="gbk-icon-span fs-16">
                  <ArrowForwardIos />
                </span>
              </Box>
              <Box sx={{ verticalAlign: 'top', clear: 'both' }}>
                <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
                  <span style={{ fontSize: '14px', color: Colors.greyDark2 }}>Max quantity per bike: {data.row.maxQuantityPerBike}</span>
                </div>
              </Box>
            </Box>
          </Box>
        )
      }}
    />
  </div >
}